<template>  
  <modal :value="value"
          max-width="750"
          content-class="sms-modal modal-device"
          :has-padding="false"
          @input="emitInput">    
    <div class="sms-modal-body">
      <h1>{{$t('message.marketingGenerics.message.testSubmission')}}</h1>

      <v-text-field v-model="phoneVal"
                    class="sms-modal-body-inpt"
                    height="30"
                    :label="$t('message.sms.message.number')"
                    persistent-hint
                    :hint="$t('message.sms.message.numberHint')"></v-text-field>

      <v-card-actions class="sms-add-plan-modal-actions">
        <button class="btn btn-extra-round  btn-outline sms-add-plan-modal-actions-skip"
                @click="skipTest">
            {{$t('message.sms.message.skipTest')}}
        </button>
        <button class="btn btn-extra-round btn-primary"
                @click="sendTest">
            {{$t('message.marketingGenerics.message.sendTest')}}
        </button>
      </v-card-actions>
    </div>
  </modal>  
</template>

<script>
import Modal from "@/components/generic/Modal";

export default {
  components: {Modal},
  data() {
    return {
      phoneVal: undefined,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    smsData: {
      type: Object,
    },
  },

  computed: {},

  watch: {},

  methods: {
    hideModal() {
      this.emitInput(false);
    },
    emitInput(value) {
      this.$emit("input", value);
    },
    async sendTest() {
      await this.$api.smsMessage.test({
        smsId: this.smsData.id,
        phoneNumber: `55${this.phoneVal}`,
      });

      this.$emit("advance");
    },
    skipTest() {
      this.$emit("advance");
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-modal {
  .sms-modal-body {
    padding: 50px 150px;

    h1 {
      text-align: center;
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 40px;
    }

    .sms-modal-body-inpt {
      margin-bottom: 20px !important;
    }

    .sms-add-plan-modal-actions {
      display: flex;
      justify-content: space-between;

      .btn {
        min-width: 200px;
      }

      .sms-add-plan-modal-actions-skip {
        border: 1px solid gray;
      }
    }
  }
}
</style>
